<h2 mat-dialog-title i18n>Copy Unit</h2>
<mat-dialog-content>
  <div class="info-block">
    <p class="mat-subtitle-1 accent-1">
      {{ project.name }} <span class="mat-caption" i18n>(Unit ID: {{ project.id }})</span>
    </p>
    <p i18n>
      Copying creates a duplicate that will appear in “My Units”. You will be the owner and can edit
      the content and share the new unit with other WISE users.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isCopying" i18n>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    (click)="copy()"
    [disabled]="isCopying"
    class="button--progress"
  >
    @if (isCopying) {
      <mat-progress-bar mode="indeterminate" />
    }
    <ng-container i18n>Copy</ng-container>
  </button>
</mat-dialog-actions>
